
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    // global.$ = global.jQuery = require('jquery');

    // fix breaking changes in jquery 3.5 for self closing tags. Affected datepicker library.
    let rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
    jQuery.htmlPrefilter = function( html ) {
      return html.replace( rxhtmlTag, "<$1></$2>" );
    };

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// let token = document.head.querySelector('meta[name="csrf-token"]');
//
// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

window.moment = require('moment');

window.queryString = require('query-string');

// use forked temporary for bootstrap 4
window.bootbox = require('bootbox');
// window.bootbox = require('bootbox/src/bootbox.js');
window.URI = require('urijs');
window.NProgress = require('nprogress');
require('jquery-pjax');
window.Tooltip = require('tooltip.js/dist/umd/tooltip');
window.sprintf = require('sprintf-js').sprintf;
window.tippy = require('tippy.js/umd/index.all');
require('@fancyapps/fancybox');
require('bootstrap-colorpicker');
window.Switchery = require('weatherstar-switch');
require('bootstrap-datepicker');

import Sortable, { MultiDrag, Swap } from 'sortablejs';
window.Sortable = Sortable;

require('jquery-jeditable');

require('bootstrap-timepicker');
require('flatpickr');
require('hierarchy-select');
// global.qtip = require('qtip2');
